"use client";

import { createContext, ReactNode, useEffect } from "react";
import * as amplitude from "@amplitude/analytics-browser";

export const AmplitudeContext = createContext(amplitude);

export function AmplitudeProvider(props: { children: ReactNode }) {
  useEffect(() => {
    amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY!, {
      autocapture: {
        elementInteractions: true,
      },
    });
  }, []);

  return (
    <AmplitudeContext.Provider value={amplitude}>
      {props.children}
    </AmplitudeContext.Provider>
  );
}
